var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"detail"},[_c('div',{staticClass:"detail__content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.noviceContent)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }